import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _PropTypes$shape;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import VisuallyHidden from "../VisuallyHidden";
import Checkbox from "./Checkbox";
import Wrapper from "./Wrapper";
import Indicator from "./Indicator";
import Label from "./Label";
import { colors } from "../../styles/theme";
var colorThemePropShape = {
  colors: PropTypes.shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, colors.primaryColor, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorText, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorActive, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorActiveText, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorHover, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorFocus, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorFocusText, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorOutline, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorDisabledLight, PropTypes.string), _defineProperty(_PropTypes$shape, colors.primaryColorDisabledDark, PropTypes.string), _PropTypes$shape))
};
var propTypes = {
  theme: PropTypes.shape(_objectSpread({
    formToggle: PropTypes.oneOf(['dark'])
  }, colorThemePropShape)),
  children: PropTypes.node,
  small: PropTypes.bool
};
var defaultProps = {
  theme: {}
};
export var FormToggle = React.forwardRef(function (_ref, ref) {
  var theme = _ref.theme,
      small = _ref.small,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["theme", "small", "children"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Checkbox, null, React.createElement(VisuallyHidden, Object.assign({
    component: "input",
    type: "checkbox",
    ref: ref
  }, props)), React.createElement(Wrapper, null, React.createElement(Indicator, null)), children && React.createElement(Label, {
    small: small
  }, children)));
});
FormToggle.darkTheme = {
  formToggle: 'dark'
};
FormToggle.propTypes = propTypes;
FormToggle.defaultProps = defaultProps;
FormToggle.displayName = 'FormToggle';
export default FormToggle;